import { Component, Inject, OnInit } from '@angular/core';
import { Subsidiary } from '../models/subsidiary.model';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-subsidiary-selector',
  standalone: false,
  templateUrl: './subsidiary-selector.component.html',
  styleUrl: './subsidiary-selector.component.scss'
})
export class SubsidiarySelectorComponent implements OnInit {
  subsidiaries: Subsidiary[] = [];
  constructor(
    public dialogRef: MatDialogRef<SubsidiarySelectorComponent>,
    @Inject(MAT_DIALOG_DATA) public data: { subsidiaries: Subsidiary[] }
  ) { }
  ngOnInit(): void {
    this.subsidiaries = this.data.subsidiaries;
  }
}
